import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const viewAllAndroidBoxes = createAsyncThunk('viewAllAndroidBoxes',
    async (object, { dispatch }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingAndroidBoxes())

        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({...object})
        }

        fetch(domainUrl + `/viewAllAndroidBoxes`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(viewAllAndroidBoxesResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error) 
                dispatch(viewAllAndroidBoxesResponse([]))
            })
    }
)
export const getMasterVendorLookup = createAsyncThunk('masterVendorsLookups',
    async (_, { dispatch }) => {

        const {userToken}= checkAuthorization()

        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        }

        fetch(domainUrl + `/masterVendorsLookups`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) 
                    dispatch(masterVendorLookupResponse(result?.data))
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error) 
               // dispatch(masterVendorLookupResponse([]))
            })
    }
)
export const getVendorUserLookup = createAsyncThunk('getVendorUserLookup',
    async (masterVendorId, { dispatch }) => {

        const {userToken}= checkAuthorization()

        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        }

        fetch(domainUrl + `/vendorsUsersLookups/`+masterVendorId, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) 
                    dispatch(vendorUserLookupResponse(result?.data))
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error) 
                dispatch(vendorUserLookupResponse([]))
            })
    }
)
export const getBoxesStatus = createAsyncThunk('getAllBoxes',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({...object})
        };
        fetch(domainUrl + `/getBoxStatus`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(addBoxesStatusResponse(result?.data))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error) 
            })
    }
)
export const getPortals = createAsyncThunk('getPortals',
    async (boxID, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingPortals())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
        };
        fetch(domainUrl +  `/getPortals/${boxID}`, requestOptions)
        .then(response => {
            if(response?.status!== 200)
                throw "auth error"
            return response.json()
        })
        .then(result => {
            if (result?.success)
                dispatch(getPortalsResponse(result?.data))
            else 
                throw result?.message
        })
        .catch(error => { 
            message.error(error) 
            dispatch(getPortalsResponse([]))
        })
    }
)

const AddBoxSlice = createSlice({
    name: 'addEditBox',
    initialState: {
        data: null,
        loading: false,
        portals: [],
        portalsLoading: [],
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {},
        masterVendorLookup:[],
        vendorUserLookup:[],
    },
    reducers: {
        gettingAndroidBoxes: state => {
            state.loading=true
        },
        viewAllAndroidBoxesResponse: (state, action)=>{
            state.data= action.payload
            state.loading= false
        },
   
        addBoxesStatusResponse: (state, action)=>{
            let tempArr= action?.payload
            state.data= state?.data?.map((box ,index)=> ({...box, dateTime: tempArr[index]?.dateTime}))
        },
        gettingPortals: (state) => {
            state.portalsLoading= true
        },
        getPortalsResponse: (state, action) => {
            state.portalsLoading= false
            state.portals= action?.payload
        },
        clearPortalsResponse: (state) => {
            state.portalsLoading= false
            state.portals= []
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        setFilters:(state, action)=>{
            state.filters= action.payload
        },
        masterVendorLookupResponse: (state, action)=>{
            state.masterVendorLookup= action.payload
        },
        vendorUserLookupResponse: (state, action)=>{
            state.vendorUserLookup= action.payload
        }
    },
})
export const { 
    gettingAndroidBoxes, viewAllAndroidBoxesResponse, 
    addBoxesStatusResponse, gettingPortals, getPortalsResponse, clearPortalsResponse,
    setPages, setFilters,
    masterVendorLookupResponse, vendorUserLookupResponse
} = AddBoxSlice.actions;
export default AddBoxSlice.reducer;